import Banner from "../Components/Shared/Layout/Banner";
import Axios from "axios";
import { useEffect, useState } from "react";

const Statistics = () => {
    const [schoolAmount, setSchoolAmount] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Axios.get("/api/data/institution/shkolle_profesionale");
                setSchoolAmount(response.data.amount);
            } catch (error) {
                console.error("Error fetching statistics data:", error);
            }
        };

        fetchData();
    }, []);

    const statisticsColumns = [
        {
            title: "Arsim profesional",
            subtitle: "Viti shkollor 2024-2025",
            stats: [
                { text: `${schoolAmount || '31'} shkolla te mesme profesionale` },
                { text: "100 punëdhënës" },
                { text: "300 nxënës zhvillojnë praktikë në biznes" },
                { text: "70% e nxenesve punesohen pas diplomimit" }
            ]
        },
        {
            title: "Arsim profesional DUAL",
            subtitle: "Viti shkollor 2024-2025",
            stats: [
                { text: "10 shkolla te mesme profesionale" },
                { text: "100 punëdhënës" },
                { text: "300 nxënës punëmarrës" },
                { text: "70% e nxenesve punesohen pas diplomimit" }
            ]
        },
        {
            title: "Formim Profesional",
            subtitle: "Regjistrime 2024",
            stats: [
                { text: "10 qendra formimi" },
                { text: "100 punëdhënës" },
                { text: "300 kursantë zhvillojnë praktike në biznes" },
                { text: "70% e kursantëve punësohen pas certifikimit" }
            ]
        }
    ];

    return (
        <>
            <Banner img='/CareerAdvice/banner.jpg' title="STATISTIKA NË AFP" />

            <div className="container mx-auto px-4 py-16">
                <div className="flex flex-wrap justify-center -mx-4">
                    {statisticsColumns.map((column, colIndex) => (
                        <div key={colIndex} className="w-full md:w-1/3 px-4 mb-8 flex flex-col items-center">

                            <div className="bg-[#C82121] text-white font-semibold py-3 px-24 rounded-md text-center text-lg shadow-lg">
                                {column.title}
                            </div>

                            <p className="mt-4 text-gray-700 font-medium">{column.subtitle}</p>

                            <div className="mt-8 w-full max-w-xs">
                                <ul className="space-y-6">
                                    {column.stats.map((stat, statIndex) => (
                                        <li key={statIndex} className="flex items-center">
                                            <img
                                                src="/icon3.svg"
                                                alt="Statistic Icon"
                                                className="w-16 h-16 mr-4 flex-shrink-0"
                                            />
                                            <span className="text-gray-800 font-medium">{stat.text}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Statistics;